import {Animated, StyleSheet} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, View} from "shared/base"
import React, {useMemo} from "react"
import LinearGradient from "react-native-linear-gradient" // eslint-disable-line import/no-named-as-default

export default memo(shapeComponent(class ImageBackgroundFading extends ShapeComponent {
  static propTypes = propTypesExact({
    children: PropTypes.node,
    imageStyle: PropTypes.object,
    resizeMode: PropTypes.string,
    source: PropTypes.string.isRequired,
    style: PropTypes.object
  })

  activeSource = "first"

  imageHeight = new Animated.Value(0)

  imageOpacity1 = new Animated.Value(100)
  imageOpacity2 = new Animated.Value(0)

  firstRender = true

  setup() {
    const {source} = this.p

    this.useStates({
      firstSource: source,
      secondSource: source
    })

    useMemo(() => {
      if (this.tt.firstRender) {
        this.firstRender = false
      } else {
        this.onSourceChange()
      }
    }, [source])
  }

  render() {
    const {children, imageStyle, resizeMode, style = emptyObject} = this.props // eslint-disable-line no-undef
    const {imageOpacity1, imageOpacity2} = this.tt
    const {firstSource, secondSource} = this.s
    const {width} = StyleSheet.flatten(style)

    const style1 = useMemo(() => [
      {width: "100%", height: "100%", opacity: imageOpacity1},
      StyleSheet.absoluteFill,
      imageStyle
    ], [imageStyle, width])

    const style2 = useMemo(() => [
      {width: "100%", height: "100%", opacity: imageOpacity2},
      StyleSheet.absoluteFill,
      imageStyle
    ], [imageStyle, width])

    const linearGradientStyle = useMemo(() => ([
      {width: "100%", height: "100%"},
      StyleSheet.absoluteFill
    ]), [width])

    return (
      <View style={style}>
        <Animated.Image
          resizeMode={resizeMode}
          source={firstSource}
          style={style1}
          testID="image-background-faded-1"
        />
        <Animated.Image
          resizeMode={resizeMode}
          source={secondSource}
          style={style2}
          testID="image-background-faded-2"
        />
        <LinearGradient
          colors={this.colors ||= ["transparent", "transparent", "#fff"]}
          end={this.LinearGradientEnd ||= {x: 0, y: 1}}
          start={this.LinearGradientStart ||= {x: 0, y: 0.5}}
          style={linearGradientStyle}
        />
        {children}
      </View>
    )
  }

  onSourceChange() {
    const {activeSource, imageOpacity1, imageOpacity2} = this.tt
    const {source} = this.p

    if (activeSource == "first") {
      this.activeSource = "second"
      this.setState({secondSource: source})

      Animated
        .timing(imageOpacity1, {
          toValue: 0,
          duration: 250,
          useNativeDriver: true
        })
        .start()

      Animated
        .timing(imageOpacity2, {
          toValue: 1,
          duration: 250,
          useNativeDriver: true
        })
        .start()
    } else {
      this.activeSource = "first"
      this.setState({firstSource: source})

      Animated
        .timing(imageOpacity1, {
          toValue: 1,
          duration: 250,
          useNativeDriver: true
        })
        .start()

      Animated
        .timing(imageOpacity2, {
          toValue: 0,
          duration: 250,
          useNativeDriver: true
        })
        .start()
    }
  }
}))
